import IndividualDetails from "./IndividualDetails";
import PracticeDetails from "./PracticeDetails";

export { IndividualDetails, PracticeDetails };
